module.exports = __webpack_public_path__ + "img-dashboard/register/facebook.8fe1673d.png";